// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","slogan":"footer_slogan__LAYUi","info":"footer_info__Wgq1F"};